import callAPiBase from './base';

const lotsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/lotList',
      method: 'GET',
      useToken: true,
      title: 'Lot - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lotCreate',
      method: 'POST',
      useToken: true,
      title: 'Lot - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lotUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Lot - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/lotDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Lot - Delete',
      params,
    }),
};

export { lotsApi };
export default lotsApi;
